var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { AbstractManager } from "./AbstractManager.js";
import { getComponentElements } from "../utils.js";
function __getChild(that, el, ComponentClass, name) {
  const asyncComponentPromise = that.__asyncComponentPromises.get(ComponentClass);
  if ("$isBase" in ComponentClass || asyncComponentPromise && asyncComponentPromise.status === "resolved") {
    let ctor = ComponentClass;
    if (asyncComponentPromise) {
      ctor = asyncComponentPromise.ctor;
    }
    if (el.__base__ && el.__base__.has(ctor)) {
      return el.__base__.get(ctor);
    }
    const child = new ctor(el);
    Object.defineProperty(child, "$parent", { get: () => that.__base });
    return child;
  }
  const promise = asyncComponentPromise ? asyncComponentPromise.promise : ComponentClass(that.__base);
  if (!asyncComponentPromise) {
    that.__asyncComponentPromises.set(ComponentClass, {
      promise,
      status: "pending",
      ctor: void 0
    });
  }
  return promise.then((module) => {
    var _a;
    const ctor = (_a = module.default) != null ? _a : module;
    that.__asyncComponentPromises.set(ComponentClass, {
      promise,
      status: "resolved",
      ctor
    });
    return __getChild(that, el, ctor, name);
  });
}
function __register(that, name, component) {
  Object.defineProperty(that, name, {
    enumerable: true,
    configurable: true,
    get: () => {
      const elements = getComponentElements(name, that.__element);
      if (elements.length === 0) {
        return [];
      }
      return elements.map((element) => __getChild(that, element, component, name)).filter((instance) => instance !== "terminated");
    }
  });
}
function __triggerHook(that, hook, instance, name) {
  if (hook === "$update" && !instance.$isMounted) {
    hook = "$mount";
  }
  if (hook === "$update" || hook === "$destroy") {
    that.__eventsManager.unbindChild(name, instance);
  }
  if (hook === "$update" || hook === "$mount") {
    that.__eventsManager.bindChild(name, instance);
  }
  instance[hook]();
}
function __triggerHookForAll(that, hook) {
  that.registeredNames.forEach((name) => {
    that[name].forEach((instance) => {
      if (instance instanceof Promise) {
        instance.then((resolvedInstance) => __triggerHook(that, hook, resolvedInstance, name));
      } else {
        __triggerHook(that, hook, instance, name);
      }
    });
  });
}
class ChildrenManager extends AbstractManager {
  constructor() {
    super(...arguments);
    __publicField(this, "__asyncComponentPromises", /* @__PURE__ */ new WeakMap());
  }
  get registeredNames() {
    return Object.keys(this).filter((key) => !key.startsWith("__"));
  }
  registerAll() {
    Object.entries(this.__config.components).forEach(
      ([name, component]) => __register(this, name, component)
    );
  }
  mountAll() {
    __triggerHookForAll(this, "$mount");
  }
  updateAll() {
    __triggerHookForAll(this, "$update");
  }
  destroyAll() {
    __triggerHookForAll(this, "$destroy");
  }
}
export {
  ChildrenManager
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
